(function() {
    angular
        .module("app")
        .factory("wvsl2Service", wvsl2Service)

        wvsl2Service.$inject = [
            "$rootScope",
            "$http"
        ]
        function wvsl2Service(
            $rootScope,
            $http
        ) {
            var service = {}

            service.setSpeedDisplay = function(messageBoardID, formData, successCallback, failureCallback) {
                return $http({
                    method: "PUT",
                    url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID + "/set_wvsl2_speed",
                    headers: {
                        "Accept": "application/json"
                    },
                    data: formData
                }).then(completed, failed)

                function completed(response) {
                    if (successCallback !== undefined) {
                        successCallback(response)
                    }
                    return response
                }

                function failed(error) {
                    if (failureCallback !== undefined) {
                        failureCallback(error)
                    }
                    console.error(error)
                }
            }
            return service
        }
})()
